<template>
  <div class="games-row">
    <div class="games" :class="currentProvider">
        <slot v-for="(item, name) in _.sortBy(games, ['sort'])"  v-if="currentCategory == 'all' || currentCategory == 'dropwins' || (_.includes(item.type, currentCategory) && (currentProvider == item.provider || currentProvider == 'all'))">
          <slot v-if="!_.isEmpty(item.details) && item.provider == 'pragmaticplay' || item.provider != 'pragmaticplay'" >
            <Game class="game-item" :style="infiniteGames(name)" :class="item.provider + '_game'"  :key="item.id + '_' + name">
              <template slot="title">{{ item.title }} </template>
              <template slot="provider">{{ item.provider }} {{ item.type }}</template>
              <template slot="is_new">
                  <div class="is_dropwins" style="display: none;" v-if="item.is_promotion == '1'">
                    <img :src="cdn_url + 'providers/dropwins.png'" alt="">
                  </div>
              </template>
              <template slot="img">
                <pragmaticDga v-show="!_.isEmpty(item.details)" :item="item" ></pragmaticDga>
                  <v-lazy-image v-if="!_.isEmpty(item.details) && item.details.tableImage" :src="item.details.tableImage"/>
                  <v-lazy-image v-else :src="item.image_full_path.replace('{domain}', current_domain).replace('https://static.egamings.com/games/', cdn_url + 'providers/')"/>
              </template>
              <template slot="play">
                <div class="buttons">
                  <button type="button" @click="runGame({id: item.id, device: isMobile})" class="button primary">Hemen Oyna</button>
                </div>
              </template>
            </Game>
          </slot>
        </slot> 

    </div>
      <infinite-loading force-use-infinite-wrapper="true" @infinite="infiniteHandler"  :identifier="identifier" ref="infiniteLoading">
        <span slot="no-more"></span>
        <span slot="spinner">
          <div class="spinner-dots"> <div class="spinner-dots--dot"></div> <div class="spinner-dots--dot"></div> <div class="spinner-dots--dot"></div> </div>
        </span>
      </infinite-loading>
  </div>
</template>

<script>
  import { ENV_CURRENT_DOMAIN, ENV_CDN_URL } from '../../plugins/replaces'
  import { mapActions } from 'vuex'
  import Game from './Game'
  import pragmaticDga from './pragmaticDga'
  import VLazyImage from "v-lazy-image/v2";
  import InfiniteLoading from 'vue-infinite-loading';
  export default{
    data(){
      return{
          limit : 34,
          identifier: +new Date(),
      }
    },
    created(){
    },
    components:{
      Game,
      pragmaticDga,
      VLazyImage,
      InfiniteLoading,
    },
    computed:{
      cdn_url(){
        return this.$store.getters['getCdnUrl'];
      },
      current_domain(){
        return ENV_CURRENT_DOMAIN;
      },
      searchValue(){
        return this.$store.getters['casino/getSearch'];
      },
      games(){
        if(this.searchValue){
          return this.$store.getters['casino/getGames'].filter(item => item.title.toLowerCase().includes(this.searchValue.toLowerCase()))
        }else{
          if(this.currentProvider == 'all'){
            return this.$store.getters['casino/getGames'];
          }else if(this.currentCategory == 'dropwins'){
            let games = _.filter(this.$store.getters['casino/getGames'], {'provider': this.currentProvider, 'is_promotion': 1})
            return _.orderBy(games, [games => games.title.toLowerCase()], ['asc'])
          }else{
            return _.filter(this.$store.getters['casino/getGames'], ['provider', this.currentProvider]);
          }
        }
      },
      currentCategory(){
        return this.$store.getters['casino/getCurrentCategory'];
      },
      currentProvider(){
        return this.$store.getters['casino/getCurrentProvider'];
      },
    },
    watch:{
      currentProvider(val){
          if(val == 'all'){
              this.limit = 20;
          }else{
              this.limit = 34;
          }
          this.identifier += 1;
      },
      currentCategory(){
          this.limit = 1000;
          this.identifier += 1;  
          setTimeout(() => {
            this.infiniteHandler();
          }, 400);
      },
    },
    methods:{
      infiniteGames(key){
          if(_.isNull(this.searchValue) || _.isEmpty(this.searchValue)){
              if(key < this.limit){
                  return ''
              }else{
                  return 'display:none'
              }
          }
      },
      infiniteHandler($state){
          let hides = document.querySelectorAll('.games .game-item[style="display: none;"]');

          setTimeout(() => {
              if(this.currentProvider == 'all'){
                  this.limit = this.limit + 20;
              }else{
                  this.limit = this.limit + 34;
              }
              $state.loaded();

              if(hides.length === 0){
                  $state.complete();
              }
          }, 300);


      },
      runGame(payload){
        if(!this.$auth()){
          this.$emit('loginModal', true);
          return false;
        }else{
          this.$store.dispatch('casino/runGame', payload)
        }
      }
    },
  }
</script>


<style lang="scss">
  #app.casino .inc .router .client-app .games .item:hover{
    .is_dropwins{
      display: none;
    }
  }
  #app.casino .inc .router .client-app .games .item .is_dropwins{
    position: absolute;  
    height: 60px; 
    z-index: 9;
    img{
      border-radius: 0px !important;
      height: 60px !important;
      border-top-left-radius: 20px !important;
    }
  }
  .item.game_is_new{
    order: 1 !important;
  }
  #app.slot .client-app .games .item{
    order: 9999;
  }
  .is_new{
    position: absolute; 
    background: #ff0000; 
    background: linear-gradient(221deg, rgb(84 3 3) 0%, rgb(255 0 0) 100%);
    padding: 3px 10px; 
    border-radius: 10px; 
    font-size: 12px; 
    top: 0px; 
    right: -5px; 
    border: 0px solid; 
    z-index: 5; 
    box-shadow: 0px 0px 10px black; 
    text-transform: uppercase; 
    font-weight: bold;
  }
</style>